import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-357acfff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-bar" }
const _hoisted_2 = { class: "contact" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系店家", -1))
const _hoisted_4 = {
  key: 0,
  class: "distributor"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的收益", -1))
const _hoisted_6 = { class: "buy" }

import {CustomerServiceOutlined} from "@ant-design/icons-vue";
import {IconFont} from "@/lib/util";
import {editor} from "@/app/editor";

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBarBasicStyle',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(CustomerServiceOutlined)),
      _hoisted_3
    ]),
    (_unref(editor).activity?.status.is_distribution)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(IconFont), { type: "icon-shouyi" }),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(editor).activity.status.buy_button_text ?? '立即抢购'), 1)
  ]))
}
}

})